@use "@fukuri-admins/ui/layout" as *;

.SideMenuFooter {
  width: 100%;

  @media screen and (max-width: $TB) {
    text-align: right;
  }

  &__DisplayName {
    padding: 0 16px 12px 16px;
    font-size: 16px;
    font-weight: bold;
    color: $NATURAL_600;
    padding-bottom: 12px;
    @media screen and (max-width: $TB) {
      padding: 0 0 4px;
      font-size: 14px;
    }
  }

  &__LogoutButton {
    padding: 0 16px 12px 16px;
    font-size: 14px;
    font-weight: 600;

    color: $NATURAL_400;
    background-color: transparent;
    cursor: pointer;
    text-decoration: underline;

    @media screen and (max-width: $TB) {
      font-size: 12px;
      padding: 0;
    }
  }
}
